import { InputForm } from "../atoms/input"

export const MatchMolecule = ({text,rang, number, leftValueText, rightValueText}) => {
    return(
        <div className="horizontal match-mol" >
         <InputForm placeholder="Voer optie in..."  typeInput={(text) => rightValueText(text)} style={{marginRight:"1rem"}} value={number}/>  
         <InputForm placeholder="Voer antwoord in..." typeInput={(text) => leftValueText(text)} value={rang}/>
        </div>
    )
}